import { render } from "./locationCard.vue?vue&type=template&id=601e246a&scoped=true"
import script from "./locationCard.vue?vue&type=script&lang=js"
export * from "./locationCard.vue?vue&type=script&lang=js"

import "./locationCard.vue?vue&type=style&index=0&id=601e246a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601e246a"]])

export default __exports__